import React from 'react';

/**
 * Componente de paginación reutilizable.
 * Muestra botones de navegación con control de límites y centrado alrededor de la página actual.
 *
 * @param {Object} props
 * @param {number} props.currentPage - Página actual (0-indexada).
 * @param {number} props.total - Número total de resultados.
 * @param {number} props.pageSize - Número de resultados por página.
 * @param {function} props.onPageChange - Función para cambiar de página.
 * @returns {JSX.Element}
 */
export default function Paginacion({ currentPage, total, pageSize, onPageChange }) {
  const totalPages = Math.ceil(total / pageSize);
  const maxButtons = 5;

  if (totalPages <= 1) return null; // No mostrar paginación si hay solo una página

  let startPage = Math.max(0, currentPage - Math.floor(maxButtons / 2));
  let endPage = Math.min(totalPages, startPage + maxButtons);

  if (endPage - startPage < maxButtons) {
    startPage = Math.max(0, endPage - maxButtons);
  }

  const createButton = (label, page, disabled = false, extraClass = '') => (
    <button
      key={label}
      type="button"
      className={extraClass}
      onClick={() => onPageChange(page)}
      disabled={disabled}
    >
      {label}
    </button>
  );

  return (
    <div id="paginacion" className="pagination-area">
      {createButton('Anterior', currentPage - 1, currentPage === 0, 'prev-button')}

      {Array.from({ length: endPage - startPage }, (_, i) => {
        const page = startPage + i;
        return createButton(page + 1, page, false, page === currentPage ? 'activo' : '');
      })}

      {createButton('Siguiente', currentPage + 1, currentPage >= totalPages - 1, 'next-button')}
    </div>
  );
}
